import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import { fromJS } from 'immutable'

import FormAdvising from 'containers/Enrolment/form-advising'
import ConfirmDialog from 'components/ConfirmDialog'
import CoverModal from 'components/CoverModal'
import { addSubjects } from 'containers/Enrolment/actions'
import { makeGetFilteredOfferings } from 'containers/Enrolment/selectors'

import ListOfferings from './list-offerings'
import ListEnrolled from './list-enrolled'

class FormContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showOfferings: false,
      showConfirm: false,
    }
  }

  _showOfferings = () => {
    this.setState({
      showOfferings: true,
    })
  }

  _hideOfferings = () => {
    this.setState({
      showOfferings: false,
    })
  }

  _showConfirm = () => {
    this.setState({
      showConfirm: true,
    })
  }

  _hideConfirm = () => {
    this.setState({
      showConfirm: false,
    })
  }

  _addSubjects = () => {
    const { dispatch, __selected, __semcampID } = this.props
    let checked = fromJS([])
    __selected.map((item) => {
      if (item.get('is_checked')) {
        checked = checked.push(item)
      }
      return true
    })
    if (checked.size > 0) {
      dispatch(addSubjects(checked, __semcampID))
        .then((res) => {
          if (!res.error) {
            dispatch(actions.change('enrolledState', fromJS(res.payload)))
            this._hideOfferings()
          }
        })
    }
  }
/*
  _onCancel = () => {
    const { dispatch, __offeringsRaw, __semcampID } = this.props
    dispatch(cancelEnrolment(__semcampID))
      .then((res) => {
        if (!res.error) {
          // set advising state
          dispatch(actions.change('advisingState', fromJS(res.payload)))
          // reset enrolledState
          dispatch(actions.reset('enrolledState'))
          dispatch(actions.change('offeringState', __offeringsRaw))
          // redirect to apply
          this.context.router.replace('/enrolment/apply')
        }
      })
  }
*/
  _renderOfferings() {
    const { showOfferings } = this.state
    if (!showOfferings) {
      return null
    }

    return (
      <CoverModal handleClose={this._hideOfferings} modalClass="subject">
        <ListOfferings
          handleClose={this._hideOfferings}
          onAdd={this._addSubjects}
        />
      </CoverModal>
    )
  }

  _renderConfirm() {
    const { showConfirm } = this.state
    const { __pending } = this.props
    if (!showConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        msg="Are you sure you want to cancel your enrolment and remove all the subjects?"
        closeDialog={this._hideConfirm}
        confirmAction={this._onCancel}
        btnClass="btn-danger"
        pending={__pending}
      />
    )
  }

  render() {
    return (
      <div>
        <div className="row m-b-20">
          <div className="col-sm-6">
            <button onClick={this._showOfferings} type="button" className="btn btn-info">Subject Offerings</button>
          </div>
          {/*<div className="col-sm-6 text-right">
            <button onClick={this._showConfirm} type="button" className="btn btn-danger">Cancel my Enrolment Application</button>
          </div>*/}
        </div>
        <FormAdvising legend="Modify Enrolment" />
        <ListEnrolled />
        {this._renderOfferings()}
        {this._renderConfirm()}
      </div>
    )
  }
}

FormContainer.contextTypes = {
  router: PropTypes.object,
}

FormContainer.propTypes = {
  __pending: PropTypes.bool,
  __offeringsRaw: PropTypes.object,
  __selected: PropTypes.object,
  __semcampID: PropTypes.number,
}

function mapStateToProps(state) {
  const getSelected = makeGetFilteredOfferings()
  return {
    __pending: state.enrolment.get('pending'),
    __offeringsRaw: state.enrolment.get('offeringsRaw'),
    __selected: getSelected(state),
    __semcampID: state.auth.getIn(['me', 'semcamp_id']),
  }
}

export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/Modify/form-container.js